import styled from 'styled-components';

export const Form = styled.div`
  width: 30rem;

  display: flex;
  flex-direction: column;

  margin-bottom: 1.5rem;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }

  @media (max-width: 375px) {
    width: 26.5rem;
  }
`;
